import path from 'path';
import fs from 'fs';

import chalk from 'chalk';
import trash from 'trash';

import { MD } from '../util/const';
import { resetGlobCache } from '../util/util';


export type TrashFn = (paths: string[]) => Promise<void>;

let _trashFn: TrashFn = trash;

/** Override the trash implementation (for testing). */
export function setTrashFn(fn: TrashFn): void { _trashFn = fn; }
/** Restore the default OS-trash implementation. */
export function resetTrashFn(): void { _trashFn = trash; }

/**
 * Move a concept note to the OS trash (recoverable).
 * `del` is the primary command; `rm` is an alias for `del --force`.
 */
export async function del(concept: string, _argv?: any): Promise<void> {
  const fp: string = path.join(process.cwd(), concept + MD);
  if (!fs.existsSync(fp)) {
    console.error(chalk.red(`no such file: ${concept}${MD}`));
    return;
  }
  await _trashFn([fp]);
  resetGlobCache();
  console.log(`trashed ${concept}${MD}`);
}
